module.exports = require("vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&id=cb7e6ad8&scoped=true&lang=css&");